import script from "./AutoScrolled.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoScrolled.vue?vue&type=script&setup=true&lang=js"

import "./AutoScrolled.vue?vue&type=style&index=0&id=dc5ede8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc5ede8e"]])

export default __exports__